import React, { useCallback, useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useDispatch, useSelector } from "react-redux";
import "./customCalendar.css";
import { format } from "date-fns";
import useStyles from "../../assets/styles/styles";
import { useHistory } from "react-router";
import { Typography, Box, CircularProgress, Card as MuiCard, CardContent, IconButton } from "@material-ui/core";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { es } from 'date-fns/locale';
import { getMedicalAgenda } from "../../redux/actions/appointmentsActions";

const userCode = parseInt(window.localStorage.getItem("numeroPersona"));

const CustomCalendarProfileMedical = ({ agendaMedical, centroMedico, especialidad }) => {

  const [onChange] = useState(null);
  const dispatch = useDispatch();
  const [indexItem, setIndexItem] = useState(new Date());
  const [selectedDayCalendar, setSelectedDayCalendar] = useState(null);
  const classes = useStyles();
  const history = useHistory();
  const [flagAppointmentSelected, setFlagAppointmentSelected] = useState(false);
  const [showMedicalCenterSelector, setShowMedicalCenterSelector] = useState(false);
  const [medicalCenters, setMedicalCenters] = useState([]);
  const [codeMedicalCenters, setCodeMedicalCenters] = useState([]);
  const [codeSpecialty, setCodeSpecialty] = useState([]);
  const modelAgendaMedicalReducer = useSelector(state => state.appointmentsReducer);
  const [modelAgendaMedical, setMedicalAgenda] = useState(modelAgendaMedicalReducer?.medicalAgenda);
  const [closestTurn, setClosestTurn] = useState([]);
  const [lastTurnOfDay, setLastTurnOfDay] = useState([]);
  const date = new Date();



  const handleClickDay = useCallback(
    (i) => (e) => {
      let selectedDate = format(e, "yyyy-MM-dd");
      setIndexItem(selectedDate);
      const dayObject = selectedDate ? new Date(selectedDate + "T00:00:00") : null;

      if (!modelAgendaMedicalReducer?.medicalAgenda?.agenda) {
        setSelectedDayCalendar(dayObject);
        return;
      }

      const shiftsOfTheDay = modelAgendaMedicalReducer?.medicalAgenda?.agenda?.filter(turno => format(new Date(turno.turnoFechHora), "yyyy-MM-dd") === selectedDate);

      if (shiftsOfTheDay.length > 0) {
        const codeMedicalCentersOfTheDay = shiftsOfTheDay?.map(turno => turno.centroMedico);
        const codeUniqueMedicalCenters = [...new Set(codeMedicalCentersOfTheDay)];
        const codeSpecialties = shiftsOfTheDay?.map(turno => turno.especialidadCodigo);
        const codeUniqueSpecialty = [...new Set(codeSpecialties)];
        const medicalCentersOfTheDay = shiftsOfTheDay?.map(turno => turno.centroMedicoDescripcion);
        const uniqueCentrosMedicos = [...new Set(medicalCentersOfTheDay)];
        setCodeMedicalCenters(codeUniqueMedicalCenters)
        setCodeSpecialty(codeUniqueSpecialty);
        setMedicalCenters(uniqueCentrosMedicos);
        setShowMedicalCenterSelector(true);
      }
      setSelectedDayCalendar(dayObject);
    },
    [indexItem]
  );

  const isSame = (dateturn) => {
    const webServiceDate = new Date(dateturn);
    const localDate = new Date(selectedDayCalendar);

    const isSameDate =
      webServiceDate.getFullYear() === localDate.getFullYear() &&
      webServiceDate.getMonth() === localDate.getMonth() &&
      webServiceDate.getDate() === localDate.getDate();
    return isSameDate;
  }

  const isDateCalendar = (shiftday) => {
    return (selectedDayCalendar != null && selectedDayCalendar?.getDate() == shiftday?.getDate() && selectedDayCalendar?.getMonth() == shiftday?.getMonth() && selectedDayCalendar?.getFullYear() == shiftday?.getFullYear());
  }

  const checkAppointments = useCallback(
    ({ date, view }) => {
      let classesToAdd = [];
      if (agendaMedical?.length > 0) {
        const filteredAgenda = agendaMedical.filter(item =>
          (!centroMedico || item.centroMedico === centroMedico.codigo) &&
          (!especialidad || item.especialidadCodigo === especialidad.codigo)
        );

        filteredAgenda.forEach(item => {
          let dateAux = new Date(item.turnoFechHora);
          let calendarDate = format(date, "yyyy-MM-dd");
          let auxDateAppointment = format(dateAux, "yyyy-MM-dd");
          if (view === "month" && calendarDate === auxDateAppointment) {
            let css = setClassDate(item, null, setFlagAppointmentSelected);
            classesToAdd.push(css);
          }
        });
      }
      return classesToAdd;
    },
    [agendaMedical, centroMedico, especialidad]
  );



  useEffect(() => {
    if (agendaMedical) {
      setMedicalAgenda(agendaMedical);

      const savedDay = localStorage.getItem('selectedCalendarDay');
      if (savedDay) {
        const savedDate = new Date(savedDay);
        setSelectedDayCalendar(savedDate);
        setIndexItem(format(savedDate, "yyyy-MM-dd"));

        const shiftsOfTheDay = agendaMedical.filter(turno =>
          format(new Date(turno.turnoFechHora), "yyyy-MM-dd") === format(savedDate, "yyyy-MM-dd")
        );

        if (shiftsOfTheDay.length > 0) {
          const codeMedicalCentersOfTheDay = shiftsOfTheDay?.map(turno => turno.centroMedico);
          const codeUniqueMedicalCenters = [...new Set(codeMedicalCentersOfTheDay)];
          const codeSpecialties = shiftsOfTheDay?.map(turno => turno.especialidadCodigo);
          const codeUniqueSpecialty = [...new Set(codeSpecialties)];
          const medicalCentersOfTheDay = shiftsOfTheDay?.map(turno => turno.centroMedicoDescripcion);
          const uniqueCentrosMedicos = [...new Set(medicalCentersOfTheDay)];
          setCodeMedicalCenters(codeUniqueMedicalCenters);
          setCodeSpecialty(codeUniqueSpecialty);
          setMedicalCenters(uniqueCentrosMedicos);
          setShowMedicalCenterSelector(true);
        }
      }

    }
  }, [agendaMedical, centroMedico, especialidad]);



  useEffect(() => {
    const savedData = localStorage.getItem('handleCalendarClick');

    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setMedicalAgenda(parsedData.agendaMedical);
      setSelectedDayCalendar(new Date(parsedData.selectedDay + "T00:00:00"));
      setMedicalCenters(parsedData.medicalCenters);
      setShowMedicalCenterSelector(parsedData.medicalCenters.length > 0);
    } else if (modelAgendaMedical) {
      setMedicalAgenda(modelAgendaMedical);
    }
  }, []);

  useEffect(() => {
    if (agendaMedical && modelAgendaMedicalReducer?.medicalAgenda !== undefined && flagAppointmentSelected) {
      document.getElementsByClassName("agenda")?.[0]?.click();
    }
  }, [flagAppointmentSelected]);

  const getFilteredAppointments = (centro, especialidad) => {
    return modelAgendaMedical?.filter(
      (turno) =>
        turno.centroMedicoDescripcion.trim().toUpperCase() === centro.trim().toUpperCase() &&
        turno.especialidadDescripcion.trim().toUpperCase() === especialidad.trim().toUpperCase() &&
        turno.estadoTurno.trim().toUpperCase() === "ASIGNADO" &&
        isSame(turno.turnoFechHora)
    );
  };

  const handleCalendarClick = (centro, especialidad) => {
    const selectedDate = selectedDayCalendar

    const shiftsOfTheDay = agendaMedical?.filter(turno => {
      return turno.centroMedicoDescripcion.trim().toUpperCase() === centro.trim().toUpperCase() &&
        turno.especialidadDescripcion.trim().toUpperCase() === especialidad.trim().toUpperCase() &&
        isSame(turno.turnoFechHora);
    });

    const businessHours = shiftsOfTheDay?.map(turno => {
      return `${turno.agendaHoraDesde}hs a ${turno.agendaHoraHasta}hs`;
    }).join(" | ");

    const dataMedicaFilter = {
      codeMedicalCenters,
      medicalCenters,
      codeSpecialty,
      agendaMedical,
      closestTurn,
      lastTurnOfDay,
      selectedDay: format(selectedDate, "yyyy-MM-dd"),
      centro,
      especialidad,
      businessHours,
      fromCalendar: true,
    };
    localStorage.setItem('handleCalendarClick', JSON.stringify(dataMedicaFilter));
    localStorage.setItem('selectedCalendarDay', selectedDate.toISOString());


    history.push({
      pathname: '/PatientAgenda',
      state: dataMedicaFilter,
    });
  };

  const formatSelectedDate = (date) => {
    if (!date) return "";
    const formattedDate = format(date, "eeee dd 'de' MMMM", { locale: es });

    const dateuppercase = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

    return dateuppercase;
  };


  const CenteredCircularProgress = () => {
    return (
      <div className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.circularProgress}`}>
        <CircularProgress />
      </div>
    );
  }


  const groupAppointments = (appointments) => {
    return appointments.reduce((groups, appointment) => {
      const centroMedico = appointment.centroMedicoDescripcion;
      const especialidad = appointment.especialidadDescripcion;
      const horarioDesde = appointment.agendaHoraDesde;
      const horarioHasta = appointment.agendaHoraHasta;

      if (!groups[centroMedico]) {
        groups[centroMedico] = {};
      }

      if (!groups[centroMedico][especialidad]) {
        groups[centroMedico][especialidad] = [];
      }

      if (!groups[centroMedico][especialidad][`${horarioDesde} - ${horarioHasta}`]) {
        groups[centroMedico][especialidad][`${horarioDesde} - ${horarioHasta}`] = [];
      }

      groups[centroMedico][especialidad][`${horarioDesde} - ${horarioHasta}`].push(appointment);
      return groups;
    }, {});
  };


  useEffect(() => {
    if (agendaMedical?.length > 0) {
      const closest = agendaMedical?.reduce((prev, current) => {
        return new Date(prev?.turnoFechHora) < new Date(current?.turnoFechHora) ? prev : current;
      });
      setClosestTurn(closest);

      const lastTurn = agendaMedical?.filter(turno => {
        return new Date(turno?.turnoFechHora).toDateString() === new Date(closest?.turnoFechHora).toDateString();
      }).reduce((prev, current) => {
        return new Date(prev?.turnoFechHora) > new Date(current?.turnoFechHora) ? prev : current;
      });
      setLastTurnOfDay(lastTurn);
    }
  }, [indexItem, date]);


  useEffect(() => {
    setSelectedDayCalendar(null);
    setShowMedicalCenterSelector(false);
  }, [centroMedico, especialidad]);


  useEffect(() => {

    const paramAll = {
      fechaDesde: date?.toISOString()?.split('T')[0],
      fechaHasta: format(date?.setMonth(date?.getMonth() + 1), 'yyyy-MM-dd'),
      numeroPersona: userCode,
      medicoCodigo: modelAgendaMedical?.medicoCodigo ? modelAgendaMedical.medicoCodigo.toString() : undefined,
      parametroAgenda: "TODOS",
    };

    dispatch(getMedicalAgenda(paramAll));
    localStorage.setItem('medicalAgendaParams', JSON.stringify(paramAll));

  }, []);


  const firstTurnOfDay = (specialty, centerMedical) => {
    const fecha = agendaMedical?.filter(turno => turno.estadoTurno.trim().toUpperCase() === "ASIGNADO" && turno.especialidadDescripcion.trim().toUpperCase() === specialty.trim().toUpperCase() && turno.centroMedicoDescripcion.trim().toUpperCase() === centerMedical.trim().toUpperCase() && isSame(turno.turnoFechHora)).reduce((prev, current) => {
      return new Date(prev?.turnoFechHora) < new Date(current?.turnoFechHora) ? prev : current;
    }, null)?.turnoFechHora
    const fechaFormateada = new Date(fecha);
    const hours = fechaFormateada.getHours().toString().padStart(2, '0');
    const minutes = fechaFormateada.getMinutes().toString().padStart(2, '0');
    const timeWithoutSeconds = `${hours}:${minutes}`;
    return isNaN(fechaFormateada.getTime()) ? "-" : timeWithoutSeconds;
  }

  return (
    <Box className={classes.txtHomeAgendaMedica}>
      <Box className={classes.txtCalendarMedicalAgenda}>

        {!agendaMedical ? (
          <CenteredCircularProgress />
        ) : (
          <Calendar
            onChange={onChange}
            onClickDay={handleClickDay()}
            showNeighboringMonth={false}
            locale="es-ES"
            value={selectedDayCalendar}
            tileClassName={({ date }) => isDateCalendar(date) ? "activeDay" : checkAppointments({ date, view: "month" })}
            next2AriaLabel={null}
            next2Label={null}
            prev2AriaLabel={null}
            prev2Label={null}
          />
        )}
      </Box>
      {selectedDayCalendar && showMedicalCenterSelector && (
        <Box className={`${classes.viewCalendarMedical}`} >
          <Typography className={classes.calendarSelectedDays} >
            {formatSelectedDate(selectedDayCalendar)}
          </Typography>
          <Box className={`${classes.divSectionCalendarMedica}`} >
            {modelAgendaMedicalReducer?.medicalAgenda?.agenda?.filter(turno => {
              const turnoFecha = format(new Date(turno.turnoFechHora), "yyyy-MM-dd");
              const selectedDate = format(selectedDayCalendar, "yyyy-MM-dd");
              return turnoFecha === selectedDate &&
                (!centroMedico || turno.centroMedico === centroMedico.codigo) &&
                (!especialidad || turno.especialidadCodigo === especialidad.codigo);
            }).length > 0 && (
                Object.entries(groupAppointments(modelAgendaMedicalReducer?.medicalAgenda?.agenda.filter(turno => {
                  const turnoFecha = format(new Date(turno.turnoFechHora), "yyyy-MM-dd");
                  const selectedDate = format(selectedDayCalendar, "yyyy-MM-dd");
                  return turnoFecha === selectedDate &&
                    (!centroMedico || turno.centroMedico === centroMedico.codigo) &&
                    (!especialidad || turno.especialidadCodigo === especialidad.codigo);
                }))).map(([centroMedico, especialidades]) => (
                  Object.entries(especialidades).map(([especialidad, horarios]) => (
                    <MuiCard key={`${centroMedico}-${especialidad}`} className={`${classes.agendaMuiCardStyles}`} >
                      <CardContent className={classes.cardContentMuiCard}>
                        <Box className={classes.divCardContentCustomCalendarMedicalProfile}>
                          <Box className={classes.cartillaMedicalCenterSection}>
                            <LocationCityIcon className={classes.LocationCityIcon} />
                          </Box>
                          <Box className={classes.detailCardCenterAgendaMedical}>
                            <Typography className={classes.txtCardDescriptionHourTurn}>
                              <Typography className={`${classes.txtCardDescriptionMedicalAgenda}`}>
                                {centroMedico}
                              </Typography>
                              <Typography className={`${classes.txtCardDescriptionMedicalSpecialty}`}>
                                {especialidad}
                              </Typography>
                              <Box component="span">
                                <Typography component="span" className={classes.txtCardDescriptionHourTurnBox}>
                                  Horario
                                </Typography>
                                <Typography component="span" className={classes.detailCardHour}>
                                  {Object.keys(horarios).map((horario, index) => (
                                    <Typography sx={{ fontSize: "inherit" }} component="span" key={index}>
                                      {horario.split(" - ").map((hora) => `${hora}hs`).join(" a ")}
                                      {index < Object.keys(horarios).length - 1 ? " | " : ""}
                                    </Typography>
                                  ))}
                                </Typography>
                              </Box>
                            </Typography>
                            <Typography className={classes.txtCardDescriptionFirstShift}>
                              <Typography sx={{ fontSize: "inherit" }} component="span" className={classes.txtCardDescriptionBox}>
                                Turnos:
                              </Typography>
                              <Typography sx={{ fontSize: "inherit" }} component="span" className={classes.txtCardDescriptionBoxGetFilteredAppointments}>
                                {getFilteredAppointments(centroMedico, especialidad)?.length}
                              </Typography>
                            </Typography>
                            <Typography className={classes.txtCardDescriptionFirstShift}>
                              <Typography sx={{ fontSize: "inherit" }} component="span" className={classes.txtCardDescriptionBox}>
                                Primer Turno:
                              </Typography>
                              <Typography sx={{ fontSize: "inherit" }} component="span" className={classes.txtCardDescriptionBoxFirstTurnOfDay}>
                                {firstTurnOfDay(especialidad, centroMedico)}
                              </Typography>
                            </Typography>
                          </Box>
                        </Box>
                        <Box className={classes.divCardContentView}>
                          <Box className={classes.buttonZoneSection}>
                            <Box className={classes.buttonZoneContainerCalendarProfileMedical}>
                              <Box>
                                <IconButton
                                  className={classes.divCardIconView}
                                  onClick={() => handleCalendarClick(centroMedico, especialidad)}
                                  customClass={classes.customHeaderBtn}
                                >
                                  <Typography className={classes.txtCardIconView}>
                                    VER
                                  </Typography>
                                  <ControlPointOutlinedIcon className={classes.iconControlPointOutlinedIcon} />
                                </IconButton>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </MuiCard>
                  ))
                ))
              )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default React.memo(CustomCalendarProfileMedical, (prevProps, nextProps) => {
  return prevProps.agendaMedical === nextProps.agendaMedical &&
    prevProps.centroMedico === nextProps.centroMedico &&
    prevProps.especialidad === nextProps.especialidad;
});

function setClassDate(item, agendaMedical, setFlagAppointmentSelected) {
  const DEFAULT_CSS_CLASS = 'asignado';
  const CSS_CLASSES = {
    DISPONIBLE: 'disponible',
    LICENCIA: 'licencia',
    'Sin-Turno': 'sinTurno',
    ASIGNADO: 'agenda',
  };
  let cssAppointmentState = DEFAULT_CSS_CLASS;
  if (agendaMedical) {
    cssAppointmentState = CSS_CLASSES[item.estadoTurno] || DEFAULT_CSS_CLASS;
    if (item.turnoFechHora.split('T')[0] === agendaMedical) {
      cssAppointmentState = CSS_CLASSES['ASIGNADO'];
      setFlagAppointmentSelected(true);
    }
  }
  return cssAppointmentState;
}

